import { OrganizationDomains } from 'types/organization';

export const getBaseOrganizationDomain = ({
	hostname,
	customId,
}: {
	hostname: string;
	customId: string;
}): ArrayType<OrganizationDomains> => ({
	id: null,
	domain: `${hostname}/${customId}`,
	type: 'Default',
	status: 'valid',
	prefixes: null,
	proxyAlias: null,
});

type GetStoryCustomDomainProps = {
	domainId: ArrayType<OrganizationDomains>['id'];
	domains: OrganizationDomains;
};

type DomainPublicHost = Pick<ArrayType<OrganizationDomains>, 'domain' | 'proxyAlias'>;

/** Hostname for published story links: proxyAlias when set, else domain. */
export const getDomainPublicHostname = (domain: DomainPublicHost) => domain.proxyAlias || domain.domain;

export const findStoryCustomDomain = (props: GetStoryCustomDomainProps) => {
	return props.domains?.find?.(domain => domain.type === 'Custom' && `${domain.id}` === `${props.domainId}`);
};

/** Props for UrlHelper.getPublishedUrl from selected org custom domain. */
export const getStoryPublishedDomainProps = (props: GetStoryCustomDomainProps) => {
	const entry = findStoryCustomDomain(props);
	if (!entry) return {};
	return {
		customDomain: getDomainPublicHostname(entry),
		pathPrefixes: entry.prefixes,
	};
};

// get url to story by custom domain id
export const getStoryCustomDomain = (props: GetStoryCustomDomainProps) => {
	const entry = findStoryCustomDomain(props);
	return entry ? getDomainPublicHostname(entry) : undefined;
};
